module.exports = __webpack_public_path__ + "static/media/Custom_ETL_Software.0f14e4e6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/Custom_ETL_Software.pdf
// module id = 409
// module chunks = 0